import React from 'react';

import { ReactComponent as DownloadIcon } from '../../assets/svg/download.svg';
import { ReactComponent as DownloadWhiteIcon } from '../../assets/svg/download-white.svg';
import { ReactComponent as LockIcon } from '../../assets/svg/locker-icon.svg';
import { ReactComponent as CheckmarkIcon } from '../../assets/svg/checkmark-green.svg';

import styles from './index.module.scss';

export enum ActionState {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LOCKED = 'locked',
  COMPLETED = 'completed',
}

const IconsByActionState: Record<ActionState, React.ReactNode> = {
  [ActionState.PRIMARY]: <DownloadWhiteIcon />,
  [ActionState.SECONDARY]: <DownloadIcon />,
  [ActionState.LOCKED]: <LockIcon />,
  [ActionState.COMPLETED]: <CheckmarkIcon />,
};

export interface ActionStateBannerStyleDownloadButtonProps {
  title: string;
  subtitle?: string;
  imageUrl?: string;
  imageAlt?: string;
  actionState?: ActionState;
  backgroundColor?: string;
  textColor?: string;
  subtitleColor?: string;
  onClick: () => void;
  error?: boolean;
  downloadError?: boolean;
  children?: React.ReactNode;
}

const ActionStateBannerStyleDownloadButton: React.FC<
  ActionStateBannerStyleDownloadButtonProps
> = ({ actionState = ActionState.PRIMARY, children }) => {
  const iconRightItem = IconsByActionState[actionState];

  return (
    <div className={styles.wrapper}>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            ...child.props,
            iconRight: iconRightItem,
            className: styles[actionState],
          });
        }
        return child;
      })}
    </div>
  );
};

export default ActionStateBannerStyleDownloadButton;
